import React from 'react';
import { Navbar } from '../../components';
import { Footer } from '../../containers';
import "./sitemap.css";

const Sitemap = () => {
  return (
    <div className="sitemap">
        <Navbar />
        <div className="sitemap__container">
            <div className="sitemap__header">
                <h1 className="h1">Etheware Site Map</h1>
            </div>
            <div className="sitemap__links">
                <div className="sitemap-links__div">
                    <h4>About Etheware</h4>
                    <p><a href="/company">Who is Etheware</a></p>
                    <p><a href="/contact">Contact Etheware</a></p>
                    <p><a href="https://es.etheware.com">ES Manager</a></p>
                    <p><a href="/legal">Legal</a></p>
                </div>

                <div className="sitemap-links__div">
                    <h4>Account</h4>
                    <p><a href="https://auth.etheware.com">Manage Your Etheware ID</a></p>
                    <p><a href="https://auth.etheware.com/sign-up">Create an Account</a></p>
                </div>


                <div className="sitemap-links__div">
                    <h4>Support</h4>
                    <p><a href="/support">Etheware Support</a></p>
                </div>
                <div className="sitemap-links__div">
                    <h4>Etheware Information</h4>
                    <p><a href="/etheware-difference">The Etheware Difference</a></p>
                    <p><a href="/how-it-works">How It Works</a></p>
                </div>
            </div>
        </div>
        <Footer />
    </div>
  )
}

export default Sitemap